module.exports = __webpack_public_path__ + "media/images/SpecialBannerMobile-c3f132046ea8b87e72c44973abf5a6e3.png";